// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* UserAnalyticsPanel.css */

.analytics-panel {
  width: 100vw;
  height: 100vh;
  background: linear-gradient(135deg, #1e1b4b 0%, #312e81 100%);
  color: #ffffff;
  overflow-y: auto;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  padding: 20px;
}

/* Header */
.analytics-header {
  padding: 20px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 3px;
  backdrop-filter: blur(10px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.analytics-header h1 {
  margin: 0;
  font-size: 2rem;
  font-weight: 700;
}

.header-controls {
  display: flex;
  gap: 20px;
  align-items: center;
}

.connection-status {
  padding: 8px 16px;
  border-radius: 3px;
  font-size: 0.9rem;
  font-weight: 600;
}

.connection-status.connected {
  background: rgba(34, 197, 94, 0.2);
  color: #22c55e;
}

.connection-status.disconnected {
  background: rgba(239, 68, 68, 0.2);
  color: #ef4444;
}

.connection-status.error {
  background: rgba(239, 68, 68, 0.2);
  color: #ef4444;
}

.last-update {
  font-size: 0.9rem;
  color: #d1d5db;
}

/* Error Message */
.analytics-error-message {
  padding: 40px;
  text-align: center;
  font-size: 18px;
  color: rgba(255, 255, 255, 0.7);
}

/* Summary Statistics */
.summary-stats {
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.stat-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 3px;
  padding: 8px 12px;
  backdrop-filter: blur(10px);
  transition: background 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
}

.stat-card:hover {
  background: rgba(255, 255, 255, 0.08);
}

.stat-value {
  font-size: 1rem;
  font-weight: 700;
  color: #a78bfa;
}

.stat-label {
  font-size: 0.9rem;
  color: #d1d5db;
}

/* Main Content Grid */
.analytics-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 30px;
}

/* Map Section */
.map-section {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 3px;
  backdrop-filter: blur(10px);
  padding: 20px;
  overflow: hidden;
}

.map-section h2 {
  margin: 0 0 16px 0;
  font-size: 1.3rem;
  color: #ffffff;
}

.map-container {
  height: 500px;
  border-radius: 3px;
  overflow: hidden;
  background: #1e293b;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  font-size: 1.2rem;
  border: 2px dashed rgba(148, 163, 184, 0.3);
}

/* Leaflet popup styling */
.marker-popup {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  min-width: 180px;
}

.marker-popup strong {
  display: block;
  font-size: 16px;
  margin-bottom: 8px;
  color: #1a1a1a;
}

.marker-popup .host-badge {
  margin-left: 8px;
  font-size: 14px;
}

.marker-popup > div {
  font-size: 13px;
  color: #444;
  margin: 4px 0;
}

.popup-stats {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #ddd;
  font-size: 12px;
}

/* User List Section */
.user-list-section {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 3px;
  backdrop-filter: blur(10px);
  padding: 20px;
}

.user-list-section h2 {
  margin: 0 0 16px 0;
  font-size: 1.3rem;
  color: #ffffff;
}

.user-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 10px;
  max-height: none;
  overflow-y: visible;
}

/* Custom scrollbar */
.user-list::-webkit-scrollbar {
  width: 8px;
}

.user-list::-webkit-scrollbar-track {
  background: #1a1a1a;
  border-radius: 4px;
}

.user-list::-webkit-scrollbar-thumb {
  background: #8b5cf6;
  border-radius: 4px;
}

.user-card {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 3px;
  padding: 10px;
  transition: all 0.2s;
}

.user-card:hover {
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(139, 92, 246, 0.5);
}

.user-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.user-name {
  font-size: 0.95rem;
  font-weight: 700;
  color: #ffffff;
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.host-badge {
  background: linear-gradient(135deg, #fbbf24, #f59e0b);
  padding: 1px 6px;
  border-radius: 3px;
  font-size: 0.65rem;
  font-weight: 600;
}

.browser-badge {
  background: rgba(239, 68, 68, 0.2);
  color: #ef4444;
  padding: 1px 6px;
  border-radius: 3px;
  font-size: 0.65rem;
  font-weight: 600;
}

.device-badge {
  background: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
  padding: 1px 6px;
  border-radius: 3px;
  font-size: 0.65rem;
  font-weight: 600;
}

.user-device {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
}

.user-location {
  font-size: 0.8rem;
  color: #a78bfa;
  margin-bottom: 8px;
}

.user-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 4px;
  margin-bottom: 8px;
}

.stat-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 6px 8px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 3px;
  font-size: 0.7rem;
}

.stat-label-text {
  color: #9ca3af;
  font-size: 0.65rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.stat-value-text {
  color: #e5e7eb;
  font-size: 0.75rem;
  font-weight: 600;
}

.user-footer {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #444;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
}

/* Distribution Section */
.distribution-section {
  grid-column: 2;
  grid-row: 2;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.distribution-card {
  background: #2a2a2a;
  border: 1px solid #8b5cf6;
  border-radius: 12px;
  padding: 20px;
}

.distribution-card h3 {
  margin: 0 0 12px 0;
  font-size: 16px;
  color: #ffffff;
}

.distribution-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.distribution-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: #333;
  border-radius: 6px;
  font-size: 14px;
}

.distribution-label {
  color: rgba(255, 255, 255, 0.9);
}

.distribution-value {
  color: #8b5cf6;
  font-weight: 600;
}

/* Responsive Design */
@media (max-width: 1400px) {
  .analytics-content {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto auto;
  }

  .map-section {
    grid-column: 1;
    grid-row: 1;
  }

  .user-list-section {
    grid-column: 1;
    grid-row: 2;
  }

  .distribution-section {
    grid-column: 1;
    grid-row: 3;
    flex-direction: row;
  }
}

@media (max-width: 768px) {
  .analytics-header {
    flex-direction: column;
    gap: 16px;
  }

  .summary-stats {
    grid-template-columns: 1fr 1fr;
  }

  .distribution-section {
    flex-direction: column;
  }

  .map-container {
    height: 400px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/UserAnalyticsPanel.css"],"names":[],"mappings":"AAAA,2BAA2B;;AAE3B;EACE,YAAY;EACZ,aAAa;EACb,6DAA6D;EAC7D,cAAc;EACd,gBAAgB;EAChB,gFAAgF;EAChF,aAAa;AACf;;AAEA,WAAW;AACX;EACE,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,+BAA+B;AACjC;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,iBAAiB;EACjB,2BAA2B;EAC3B,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,qCAAqC;EACrC,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA,0BAA0B;AAC1B;EACE,gFAAgF;EAChF,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,qCAAqC;EACrC,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,qDAAqD;EACrD,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,+BAA+B;AACjC;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;IAC1B,kCAAkC;EACpC;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,cAAc;IACd,WAAW;IACX,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* UserAnalyticsPanel.css */\n\n.analytics-panel {\n  width: 100vw;\n  height: 100vh;\n  background: linear-gradient(135deg, #1e1b4b 0%, #312e81 100%);\n  color: #ffffff;\n  overflow-y: auto;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;\n  padding: 20px;\n}\n\n/* Header */\n.analytics-header {\n  padding: 20px;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 3px;\n  backdrop-filter: blur(10px);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n}\n\n.analytics-header h1 {\n  margin: 0;\n  font-size: 2rem;\n  font-weight: 700;\n}\n\n.header-controls {\n  display: flex;\n  gap: 20px;\n  align-items: center;\n}\n\n.connection-status {\n  padding: 8px 16px;\n  border-radius: 3px;\n  font-size: 0.9rem;\n  font-weight: 600;\n}\n\n.connection-status.connected {\n  background: rgba(34, 197, 94, 0.2);\n  color: #22c55e;\n}\n\n.connection-status.disconnected {\n  background: rgba(239, 68, 68, 0.2);\n  color: #ef4444;\n}\n\n.connection-status.error {\n  background: rgba(239, 68, 68, 0.2);\n  color: #ef4444;\n}\n\n.last-update {\n  font-size: 0.9rem;\n  color: #d1d5db;\n}\n\n/* Error Message */\n.analytics-error-message {\n  padding: 40px;\n  text-align: center;\n  font-size: 18px;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n/* Summary Statistics */\n.summary-stats {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n}\n\n.stat-card {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 3px;\n  padding: 8px 12px;\n  backdrop-filter: blur(10px);\n  transition: background 0.2s;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.stat-card:hover {\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.stat-value {\n  font-size: 1rem;\n  font-weight: 700;\n  color: #a78bfa;\n}\n\n.stat-label {\n  font-size: 0.9rem;\n  color: #d1d5db;\n}\n\n/* Main Content Grid */\n.analytics-content {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  margin-bottom: 30px;\n}\n\n/* Map Section */\n.map-section {\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 3px;\n  backdrop-filter: blur(10px);\n  padding: 20px;\n  overflow: hidden;\n}\n\n.map-section h2 {\n  margin: 0 0 16px 0;\n  font-size: 1.3rem;\n  color: #ffffff;\n}\n\n.map-container {\n  height: 500px;\n  border-radius: 3px;\n  overflow: hidden;\n  background: #1e293b;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #94a3b8;\n  font-size: 1.2rem;\n  border: 2px dashed rgba(148, 163, 184, 0.3);\n}\n\n/* Leaflet popup styling */\n.marker-popup {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;\n  min-width: 180px;\n}\n\n.marker-popup strong {\n  display: block;\n  font-size: 16px;\n  margin-bottom: 8px;\n  color: #1a1a1a;\n}\n\n.marker-popup .host-badge {\n  margin-left: 8px;\n  font-size: 14px;\n}\n\n.marker-popup > div {\n  font-size: 13px;\n  color: #444;\n  margin: 4px 0;\n}\n\n.popup-stats {\n  margin-top: 8px;\n  padding-top: 8px;\n  border-top: 1px solid #ddd;\n  font-size: 12px;\n}\n\n/* User List Section */\n.user-list-section {\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 3px;\n  backdrop-filter: blur(10px);\n  padding: 20px;\n}\n\n.user-list-section h2 {\n  margin: 0 0 16px 0;\n  font-size: 1.3rem;\n  color: #ffffff;\n}\n\n.user-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 10px;\n  max-height: none;\n  overflow-y: visible;\n}\n\n/* Custom scrollbar */\n.user-list::-webkit-scrollbar {\n  width: 8px;\n}\n\n.user-list::-webkit-scrollbar-track {\n  background: #1a1a1a;\n  border-radius: 4px;\n}\n\n.user-list::-webkit-scrollbar-thumb {\n  background: #8b5cf6;\n  border-radius: 4px;\n}\n\n.user-card {\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 3px;\n  padding: 10px;\n  transition: all 0.2s;\n}\n\n.user-card:hover {\n  background: rgba(255, 255, 255, 0.12);\n  border-color: rgba(139, 92, 246, 0.5);\n}\n\n.user-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 6px;\n}\n\n.user-name {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: #ffffff;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.host-badge {\n  background: linear-gradient(135deg, #fbbf24, #f59e0b);\n  padding: 1px 6px;\n  border-radius: 3px;\n  font-size: 0.65rem;\n  font-weight: 600;\n}\n\n.browser-badge {\n  background: rgba(239, 68, 68, 0.2);\n  color: #ef4444;\n  padding: 1px 6px;\n  border-radius: 3px;\n  font-size: 0.65rem;\n  font-weight: 600;\n}\n\n.device-badge {\n  background: rgba(59, 130, 246, 0.2);\n  color: #3b82f6;\n  padding: 1px 6px;\n  border-radius: 3px;\n  font-size: 0.65rem;\n  font-weight: 600;\n}\n\n.user-device {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.user-location {\n  font-size: 0.8rem;\n  color: #a78bfa;\n  margin-bottom: 8px;\n}\n\n.user-stats {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 4px;\n  margin-bottom: 8px;\n}\n\n.stat-item {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 6px 8px;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 3px;\n  font-size: 0.7rem;\n}\n\n.stat-label-text {\n  color: #9ca3af;\n  font-size: 0.65rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.stat-value-text {\n  color: #e5e7eb;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.user-footer {\n  margin-top: 8px;\n  padding-top: 8px;\n  border-top: 1px solid #444;\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n/* Distribution Section */\n.distribution-section {\n  grid-column: 2;\n  grid-row: 2;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.distribution-card {\n  background: #2a2a2a;\n  border: 1px solid #8b5cf6;\n  border-radius: 12px;\n  padding: 20px;\n}\n\n.distribution-card h3 {\n  margin: 0 0 12px 0;\n  font-size: 16px;\n  color: #ffffff;\n}\n\n.distribution-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.distribution-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 12px;\n  background: #333;\n  border-radius: 6px;\n  font-size: 14px;\n}\n\n.distribution-label {\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.distribution-value {\n  color: #8b5cf6;\n  font-weight: 600;\n}\n\n/* Responsive Design */\n@media (max-width: 1400px) {\n  .analytics-content {\n    grid-template-columns: 1fr;\n    grid-template-rows: auto auto auto;\n  }\n\n  .map-section {\n    grid-column: 1;\n    grid-row: 1;\n  }\n\n  .user-list-section {\n    grid-column: 1;\n    grid-row: 2;\n  }\n\n  .distribution-section {\n    grid-column: 1;\n    grid-row: 3;\n    flex-direction: row;\n  }\n}\n\n@media (max-width: 768px) {\n  .analytics-header {\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .summary-stats {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .distribution-section {\n    flex-direction: column;\n  }\n\n  .map-container {\n    height: 400px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
